import { render } from "./Settings.vue?vue&type=template&id=5029510a&scoped=true&ts=true"
import script from "./Settings.vue?vue&type=script&lang=ts"
export * from "./Settings.vue?vue&type=script&lang=ts"

import "./Settings.vue?vue&type=style&index=0&id=5029510a&scoped=true&lang=css"

import exportComponent from "/home3/sli/web/public/resources/editorvue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5029510a"]])

export default __exports__